/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Text } from "@chakra-ui/react";
import {
  FormInputGroup,
  InputFake,
  LabeFormlStyled
} from "styled/Input.styled";
import { ButtonStyled } from "styled/Buttons.styled";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { __ShowQualification } from "request/configuration/__QualificationU";
import { useSelector } from "react-redux";

export const FormShowQualificationU = () => {
  const token = useSelector((state) => state.auth.dataUser.token);

  const initialForm = {
    name_qualificationQualifiedUser: "",
    description_qualificationQualifiedUser: "",
    status_qualificationQualifiedUser: ""
  };
  const [form, setForm] = useState(initialForm);
  const { onCloseModal, dataToShow } = useContext(ConfigurationCRUDContext);

  useEffect(() => {
    if (dataToShow) {
      //   setForm(dataToShow);
      const initialpos = async () => {
        try {
          const res = await __ShowQualification(token, dataToShow.id);
          setForm(res?.data?.status?.data);
        } catch (error) {}
      };
      initialpos();
    } else {
      setForm(initialForm);
    }
  }, [dataToShow]);
  return (
    <>
      <Text
        fontSize="xl"
        mb={3}
        style={{
          fontWeight: 600,
          borderBottom: "1px solid #bababa80",
          paddingBottom: "1rem"
        }}
      >
        {dataToShow ? form.name_rol : ""}
      </Text>
      <form action="">
        <div className="row">
          <div className="col-md-6">
            <FormInputGroup>
              <LabeFormlStyled>Calificación</LabeFormlStyled>
              <InputFake>{form.name_qualificationQualifiedUser}</InputFake>
            </FormInputGroup>
          </div>
          <div className="col-md-6">
            <FormInputGroup>
              <LabeFormlStyled>Descripción</LabeFormlStyled>
              <InputFake>
                {form.description_qualificationQualifiedUser === null
                  ? "---"
                  : form.description_qualificationQualifiedUser}
              </InputFake>
            </FormInputGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <FormInputGroup>
              <LabeFormlStyled>¿Activo?</LabeFormlStyled>
              <InputFake>
                {form.status_qualificationQualifiedUser === 1
                  ? "Activo"
                  : "Inactivo"}
              </InputFake>
            </FormInputGroup>
          </div>
        </div>

        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <ButtonStyled type="button" wd="140px" onClick={onCloseModal}>
            Aceptar
          </ButtonStyled>
        </div>
      </form>
    </>
  );
};
